import { FeatureFlag as FeatureFlagLibs } from '@ally/ally-login'

enum FeatureFlagRemote {
  LastNameRemovalOLE = 'FF_last-name-removal-ole',
  BiometricsPWUnEnrollment = 'FF_biometrics-pw-unenrollment',
  DisableOAAOLE = 'FF_disable-oaa-ole',
  AutoBusinessOLE = 'FF_auto-business-ole',
  BusinessForgotPWOptions = 'FF_business-forgot-pw-options',
  AosFaqLob = 'FF_aos-faq-lob',
}

export const FeatureFlag = { ...FeatureFlagLibs, ...FeatureFlagRemote }

export type FeatureFlag = typeof FeatureFlag
